module.exports = __webpack_public_path__ + "static/media/Screen Shot 2023-02-20 at 12.27.18.f977eca0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Screen Shot 2023-02-20 at 12.27.18.png
// module id = 1242
// module chunks = 1